import React, { useState, useEffect, useRef } from 'react';
import { formatCEP, validateCEP } from '../utils/formaters';
import './CEPInput.css';

const CEPInput = ({ value = '', onChange, onAddressChange, placeholder = '00000-000', required = false, id }) => {
  const [cep, setCep] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    // Inicializar com valor formatado se houver
    if (value) {
      const formatted = formatCEP(value);
      setCep(formatted);
    }
  }, []);

  useEffect(() => {
    // Limpar timeout anterior
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Se CEP completo e válido, buscar endereço após 500ms sem digitação
    if (validateCEP(cep)) {
      timeoutRef.current = setTimeout(() => {
        fetchAddress(cep.replace(/\D/g, ''));
      }, 500);
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [cep]);

  const fetchAddress = async (cepNumbers) => {
    if (!cepNumbers || cepNumbers.length !== 8) return;

    setIsLoading(true);
    try {
      // Usar API ViaCEP (gratuita e pública)
      const response = await fetch(`https://viacep.com.br/ws/${cepNumbers}/json/`);
      const data = await response.json();

      if (data.erro) {
        console.warn('CEP não encontrado');
        return;
      }

      // Callback para atualizar endereço
      if (onAddressChange && !data.erro) {
        onAddressChange({
          cep: data.cep?.replace(/\D/g, '') || cepNumbers,
          endereco: data.logradouro || '',
          bairro: data.bairro || '',
          cidade: data.localidade || '',
          uf: data.uf || '',
          complemento: data.complemento || ''
        });
      }
    } catch (error) {
      console.error('Erro ao buscar CEP:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    const inputValue = e.target.value;
    // Permitir apenas números
    const numbersOnly = inputValue.replace(/\D/g, '');
    // Limitar a 8 dígitos
    const limitedNumbers = numbersOnly.slice(0, 8);
    const formatted = formatCEP(limitedNumbers);

    setCep(formatted);

    // Callback com valor completo (apenas números para o form)
    if (onChange) {
      onChange({ target: { value: limitedNumbers } });
    }
  };

  return (
    <div className="cep-input-wrapper">
      <input
        id={id}
        type="text"
        className="cep-input"
        value={cep}
        onChange={handleChange}
        placeholder={placeholder}
        required={required}
        maxLength={9}
      />
      {isLoading && (
        <span className="cep-loading" title="Buscando endereço...">
          🔍
        </span>
      )}
    </div>
  );
};

export default CEPInput;
